// extracted by mini-css-extract-plugin
export default {"textEditor":"QuillEditor_textEditor__b1Q7L","label":"QuillEditor_label__otb5m"};